import { useContext, useEffect, useState } from 'react';
import LensesTabsContainer from './LensesTabsContainer';
import { LenseConfig } from 'types/pricingSimulator';
import { pricingSimulatorDataContext } from 'contexts/PricingSimulatorContext';
import { useUpdateLenseConfig } from 'hooks/pricingSimulator';
import useUpdateLastViewedLense from 'hooks/pricingSimulator/lens/useUpdateLastViewedLense';
import LensConfigManger from './LensConfigManager/LensConfigManger';

const LenseSection = () => {
    const {
        selectedScenarioInfo,
        updateScenarioProperty,
        lenseConfigLoading,
        loggedInUser,
        setScrollTopValue,
        viewMode,
    } = useContext(pricingSimulatorDataContext);
    const [selectedLenses, setSelectedLenses] = useState<any[]>([]);
    const [viewModeLensUpdateLoading, setViewModeLensUpdateLoading] = useState(false); // to control closure for view mode lens update

    useEffect(() => {
        const selectedLenses = selectedScenarioInfo?.lenseConfig
            ?.filter((i: any) => i.isSelected)
            ?.map((l: LenseConfig) => {
                return { label: l.lenseName, key: l.lenseId };
            });

        if (Array.isArray(selectedLenses) && selectedLenses?.length > 0) {
            setSelectedLenses(selectedLenses);
        } else {
            setSelectedLenses([]);
        }
    }, [selectedScenarioInfo?.lenseConfig]);

    const { mutate: triggerUpdateLense, loading: isUpdateLensLoading } = useUpdateLenseConfig({
        selectedScenarioInfo,
    });

    const { mutate: triggerLastViewed } = useUpdateLastViewedLense();

    const onLensClickHandler = (lens: any) => {
        // storing current scroll position of scenario table
        const scenarioWrapperTable = document.getElementsByClassName('infinite-scroll-component')[0];
        setScrollTopValue(scenarioWrapperTable?.scrollTop || 0);
        const activeLense = selectedScenarioInfo?.lenseConfig?.find((item) => {
            return item.lenseId === lens.key;
        });

        updateScenarioProperty('activeLense', {
            activeLenseData: activeLense,
            activeLenseId: lens.key,
        });
        updateScenarioProperty('offset', 0);
        // updateScenarioProperty('sortObject', {
        //     sortBy: selectedDimensionListValues?.[0] || '',
        //     sortingOrder: 'asc',
        //     sortType: 'actual',
        // });
        // api call
        if (!viewMode) {
            triggerLastViewed({
                scenarioId: selectedScenarioInfo?.scenarioId,
                userId: loggedInUser,
                lensId: lens.key,
            });
        }
    };

    const handleSubmit = (updatedDetails: LenseConfig[]) => {
        if (viewMode) {
            const activeLense = updatedDetails.find(
                (item) => item.lenseId === selectedScenarioInfo?.activeLense?.activeLenseId,
            );
            updateScenarioProperty('activeLense', {
                activeLenseData: activeLense,
                activeLenseId: activeLense?.lenseId,
            });

            setViewModeLensUpdateLoading(true); // Set loading state to true at the start
            setTimeout(() => {
                setViewModeLensUpdateLoading(false); // Reset loading state
                updateScenarioProperty('lenseConfig', updatedDetails);
            });
        } else {
            triggerUpdateLense({
                prevState: selectedScenarioInfo?.lenseConfigBackup,
                currentState: updatedDetails,
                scenarioId: selectedScenarioInfo?.scenarioId,
                userId: loggedInUser,
            });
        }
    };

    return (
        <div className=" pt-2">
            <div className="p-2 flex items-baseline gap-2">
                <LensConfigManger
                    buttonName={'Lenses'}
                    initialConfigDetails={selectedScenarioInfo?.lenseConfig}
                    onSubmitHandler={handleSubmit}
                    outputCallLoading={viewModeLensUpdateLoading || isUpdateLensLoading}
                    isLoading={lenseConfigLoading}
                    cancelButtonLabel="Reset"
                    saveButtonLabel="Save Changes"
                    reverseIconAndText
                    showLensIcon
                    attributeHeaderName="All Market Lenses"
                />
                <LensesTabsContainer
                    onClick={(lens) => onLensClickHandler(lens)}
                    activeLensKey={selectedScenarioInfo?.activeLense?.activeLenseId || selectedLenses?.[0]?.key}
                    lenses={selectedLenses}
                />
            </div>
        </div>
    );
};

export default LenseSection;
